import { combineReducers } from "redux";
import registerReducer from "./registerReducer";
import generalReducer from "./generalReducer";
import profileReducer from "./profileReducer";
import dashboardReducer from "./dashboardReducer";
import categoryReducer from "./categoryReducer";
import projectDocumentationReducer from "./projectDocumentationReducer";
import backofficeReducer from "./backofficeReducer.ts";
import { registrationV2Reducer } from "../registrationV2/reducer.ts";
import { onboardingV2Reducer } from "../onboardingV2/reducer.ts";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import feedReducer from "../feed/reducer.ts";

const profilePersistConfig = {
  key: "profile",
  storage: storage,
  blacklist: ["showSubprojects", "projectIdForSub", "sendSubprojects", "sendProject", "projectBudgets", "sendSubQuotations", "proyectos", "proyectosLoading", "postulations", "postulationsLoading", "quotations", "viewQuotations", "viewQuotationsLoading", "publicProject", "publicQuotation", "adjudicatedProject", "userCalifications", "userCalificationsLoading", "profileVisits", "proyectoPrivadoPorId", "projectQuestions", "comments", "subProjectBudgets", "materialsBySubquotation", "subQuotations", "subQuotationsPostulations", "quotation", "project", "dataProfile", "skillProfile", "shareProfile", "menuShow", "setProjectLoading", "suscriptionLoading", "cancelSuscriptionLoading", "isFreeTrialSuccess", "goBackToCategoryList", "projectToEdit", "quotationToEdit", "openMainId", "subProjectId", "proyectoId", "projectStep1Id", "subProjectsEdit", "updatedSubProjectList", "subProjectsType", "newSkill", "profileBudgetSender", "usersInJurisdiction", "postulationsInProject", "portfolioQuestions"]
};

const generalPersistConfig = {
  key: "general",
  storage: storage,
  blacklist: ["recoverOpen", "profileVisualizer", "componentLoading", "error", "success", "openMainModal", "mainModalConfig", "openFeedTextModal", "feedModalConfig", "openNDAModal", "calificationModal", "showSendContactNotificationModal", "showSuscriptionModal", "sideNavBarExpanded", "isLoaded", "loginAnimation", "loginAnimationType", "logoutAnimation", "edifySpinner", "isGuestAccount", "loginType"]
};
const registerPersistConfig = {
  key: "register",
  storage: storage,
  blacklist: ["images", "imagesPreview", "openEdit", "personaForm", "empresaForm", "skills", "plans", "userPlan", "allJobRequests", "workBagUsers", "workBagUsersToValidate", "userPortfolios", "userSkills", "currentWorkOffer", "cities", "codeValidationData", "completeRegistrationData", "preRegisterError", "codeValidationError", "resendCodeError", "completeRegistrationError", "isPreRegistering", "isCodeValidating", "isResendingCode", "isCompletingRegistration", "name", "mail", "type", "file", "codeValidation", "isValidating", "errorMessage", "identityModal", "itemCount", "page", "totalPages", "totalSkillsListed", "planID", "portfolioId", "portfoliosLoading", "searchSkill", "selectedJurisdictions", "selectedSkill", "skillsList", "terminosStatus", "usersBySkill", "usersSkillList", "workOfferPostulation"]
};
const categoryPersistConfig = {
  key: "category",
  storage: storage,
  blacklist: ["categories"]
};

export default combineReducers({
  register: persistReducer(registerPersistConfig, registerReducer),
  general: persistReducer(generalPersistConfig, generalReducer),
  profile: persistReducer(profilePersistConfig, profileReducer),
  category: persistReducer(categoryPersistConfig, categoryReducer),
  dashboard: dashboardReducer,
  feed: feedReducer,
  anteProyecto: projectDocumentationReducer,
  backoffice: backofficeReducer,
  registrationV2: registrationV2Reducer,
  onboardingV2: onboardingV2Reducer,
});
